import { render, staticRenderFns } from "./Period2.vue?vue&type=template&id=49288c36&"
import script from "./Period2.vue?vue&type=script&lang=js&"
export * from "./Period2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports